<template>
    <div class="main">
        <b-breadcrumb :items="items"></b-breadcrumb>
    </div>
</template>

<script>
import ApiService from '../../../common/api.service';
export default {
    name: "redireciona-super-pro",
    created() {
        this.loadData()
    },
    data() {
        return {
            acesso: {
                data: [],
            },

            items: [{
                text: 'Home',
                href: '/'
            },
            {
                text: 'Segmento',
                href: '/Segmento',
                active: true
            },

            {
                text: 'Portal Super Pro',
                href: 'segmento-de-conteudo/redireciona-super-pro',
                active: true
            },

            ],
        }
    },

    methods: {
        loadData() {

            ApiService.post('v1/acesso-super-pro', {

                idUser: this.$store.state.auth.user.id
            })
                .then(response => {
                    this.acesso = response;
                    if (this.acesso.data.habilitado == 0) {
                        this.$router.push('/nao-autorizado');

                    } else {
                        const swalWithBootstrapButtons = this.$swal.mixin({
                            confirmButtonClass: 'btn btn-secondary',
                            cancelButtonClass: 'btn btn-dark mr-3',
                            buttonsStyling: false
                        });
                        swalWithBootstrapButtons
                            .fire({
                                title: 'Acesso Habilitado',
                                text: "Confirme para ser redirecionado",
                                icon: 'warning',
                                showCancelButton: true,
                                confirmButtonText: 'Sim, ir ao SuperPro-Web.',
                                cancelButtonText: 'Não, cancele.',
                                reverseButtons: true,
                                padding: '2em'
                            })
                            .then(result => {
                                if (result.value) {
                                    this.urlRedireciona();
                                    //voltar ao menu depois de redirecionado em outra aba
                                    this.$router.push('/conteudo-exclusivo')

                                } else if (result.dismiss === this.$swal.DismissReason.cancel) {
                                    this.$router.push('/conteudo-exclusivo');

                                }
                            });
                    }
                })
                .catch(function (error) {
                    console.log(error);

                    this.$swal({
                        type: "error",
                        title: "Oops...",
                        text: "Tem algo errado",
                        footer: "Tente mais tarde",
                        padding: "2em",
                    })
                })
                .finally(() => {

                });

        },
        urlRedireciona() {
            window.open(this.acesso.data.acesso.urlAcesso);
        },
    }

}
</script>

<style scoped>
.fade-in-up {
    -webkit-animation: fadeIn 0.4s ease-in-out;
    -moz-animation: fadeIn 0.4s ease-in-out;
    -o-animation: fadeIn 0.4s ease-in-out;
    animation: fadeIn 0.4s ease-in-out;
}

object {
    position: absolute;
    top: 200;
    left: 0;
    bottom: 0;
    right: 0;
    width: 100%;
    height: 100%;
    border: none;
    margin: 0;
    padding: 0;
    overflow: hidden;
    z-index: 999;
}
</style>
